import React, { useEffect } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { Card, CloseButton, Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import guestIcon from "../../assets/svg/icon-guest.svg";
import PointersLine from "../../components/Loaders/PointersLine/PointersLine.jsx";
import {
  ButtonCancel,
  ButtonCreateGroup,
  ContentSelect,
  CounterTotalUsers,
  Hr,
  IconGuest,
  SectionWrapper,
  SelectStyles,
  TextTitleList,
  useStyles,
} from "./DownloadUserManagement.styled.js";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import BackButtonComponent from "../../components/BackButtonComponent/BackButtonComponent";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { theme as themeConfig } from "../../themes/themes";

const DownloadUserManagement = ({
  closeAdvanceSearch,
  allCountries,
  handleChangeSelectCountry,
  rCities,
  allCities,
  handleChangeSelectCity,
  loadingRoleByLevel,
  errorRoleByLevel,
  allRolesByLevel,
  handleChangeSelectRole,
  allLobs,
  handleChangeSelectLob,
  totalUsersCount,
  createGroup,
  labelOfButton,
  showCheckboxes = false,
  selectedCheckbox,
  setSelectedCheckbox,
  goBack,
  loadingAdvanceUsers,
  usersListRendered,
  handleUsersAdvanceSearch,
  selectedCountryIds,
  selectedCityIds,
  selectedRoleIds,
  selectedLobIds,
}) => {
  const classes = useStyles();

  useEffect(() => {
    if (usersListRendered) {
      handleUsersAdvanceSearch();
    }
  }, [usersListRendered]);

  useEffect(() => {
    if (
      selectedCountryIds ||
      selectedCityIds.length > 0 ||
      selectedRoleIds.length > 0 ||
      selectedLobIds.length > 0
    ) {
      handleUsersAdvanceSearch();
    }
  }, [selectedCountryIds, selectedCityIds, selectedRoleIds, selectedLobIds]);

  return (
    <>
      <div
        style={{
          paddingLeft: "2rem",
          paddingRight: "2rem",
          marginTop: "1rem",
          marginBottom: "1rem",
        }}
      >
        <BackButtonComponent
          backtitle={"User Creation"}
          locationtitle={"Download"}
          goToBackPage={goBack}
          identity={"UserManagementDownload"}
        />
        <Hr style={{ width: "100%" }} className="mt-0" />
        <Accordion defaultExpanded disableGutters>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: themeConfig.neutral.white }} />}
            sx={{
              backgroundColor: themeConfig.text.primary,
              color: "white",
              border: "1px solid #2E2E2E",
              borderRadius: "4px 4px 0px 0px",
            }}
          >
            <Typography>Select Fields for report</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {showCheckboxes && (
              <>
                <Row className="mx-2 mt-2">
                  <Col md="12">
                    <p>Please select all the fields you want for your report</p>
                  </Col>
                  <Col md="3">
                    <FormControlLabel
                      control={
                        <Checkbox
                          defaultChecked={selectedCheckbox.user}
                          sx={{
                            color: themeConfig.text.primary,
                            "&.Mui-checked": {
                              color: themeConfig.text.primary,
                            },
                          }}
                          onClick={() =>
                            setSelectedCheckbox({
                              user: !selectedCheckbox.user,
                              client: selectedCheckbox.client,
                              country: selectedCheckbox.country,
                              city: selectedCheckbox.city,
                              role: selectedCheckbox.role,
                              lob: selectedCheckbox.lob,
                              tpid: selectedCheckbox.tpid,
                              username: selectedCheckbox.username,
                              userstatus: selectedCheckbox.userstatus,
                            })
                          }
                        />
                      }
                      label="User (First and last name)"
                    />
                  </Col>
                  <Col md="3">
                    <FormControlLabel
                      control={
                        <Checkbox
                          defaultChecked={selectedCheckbox.client}
                          sx={{
                            color: themeConfig.text.primary,
                            "&.Mui-checked": {
                              color: themeConfig.text.primary,
                            },
                          }}
                          onClick={() =>
                            setSelectedCheckbox({
                              user: selectedCheckbox.user,
                              client: !selectedCheckbox.client,
                              country: selectedCheckbox.country,
                              city: selectedCheckbox.city,
                              role: selectedCheckbox.role,
                              lob: selectedCheckbox.lob,
                              tpid: selectedCheckbox.tpid,
                              username: selectedCheckbox.username,
                              userstatus: selectedCheckbox.userstatus,
                            })
                          }
                        />
                      }
                      label="Client"
                    />
                  </Col>
                  <Col md="3">
                    <FormControlLabel
                      control={
                        <Checkbox
                          defaultChecked={selectedCheckbox.country}
                          sx={{
                            color: themeConfig.text.primary,
                            "&.Mui-checked": {
                              color: themeConfig.text.primary,
                            },
                          }}
                          onClick={() =>
                            setSelectedCheckbox({
                              user: selectedCheckbox.user,
                              client: selectedCheckbox.client,
                              country: !selectedCheckbox.country,
                              city: selectedCheckbox.city,
                              role: selectedCheckbox.role,
                              lob: selectedCheckbox.lob,
                              tpid: selectedCheckbox.tpid,
                              username: selectedCheckbox.username,
                              userstatus: selectedCheckbox.userstatus,
                            })
                          }
                        />
                      }
                      label="Country"
                    />
                  </Col>
                  <Col md="3">
                    <FormControlLabel
                      control={
                        <Checkbox
                          defaultChecked={selectedCheckbox.city}
                          sx={{
                            color: themeConfig.text.primary,
                            "&.Mui-checked": {
                              color: themeConfig.text.primary,
                            },
                          }}
                          onClick={() =>
                            setSelectedCheckbox({
                              user: selectedCheckbox.user,
                              client: selectedCheckbox.client,
                              country: selectedCheckbox.country,
                              city: !selectedCheckbox.city,
                              role: selectedCheckbox.role,
                              lob: selectedCheckbox.lob,
                              tpid: selectedCheckbox.tpid,
                              username: selectedCheckbox.username,
                              userstatus: selectedCheckbox.userstatus,
                            })
                          }
                        />
                      }
                      label="City"
                    />
                  </Col>
                  <Col md="3">
                    <FormControlLabel
                      control={
                        <Checkbox
                          defaultChecked={selectedCheckbox.role}
                          sx={{
                            color: themeConfig.text.primary,
                            "&.Mui-checked": {
                              color: themeConfig.text.primary,
                            },
                          }}
                          onClick={() =>
                            setSelectedCheckbox({
                              user: selectedCheckbox.user,
                              client: selectedCheckbox.client,
                              country: selectedCheckbox.country,
                              city: selectedCheckbox.city,
                              role: !selectedCheckbox.role,
                              lob: selectedCheckbox.lob,
                              tpid: selectedCheckbox.tpid,
                              username: selectedCheckbox.username,
                              userstatus: selectedCheckbox.userstatus,
                            })
                          }
                        />
                      }
                      label="Role"
                    />
                  </Col>
                  <Col md="3">
                    <FormControlLabel
                      control={
                        <Checkbox
                          defaultChecked={selectedCheckbox.lob}
                          sx={{
                            color: themeConfig.text.primary,
                            "&.Mui-checked": {
                              color: themeConfig.text.primary,
                            },
                          }}
                          onClick={() =>
                            setSelectedCheckbox({
                              user: selectedCheckbox.user,
                              client: selectedCheckbox.client,
                              country: selectedCheckbox.country,
                              city: selectedCheckbox.city,
                              role: selectedCheckbox.role,
                              lob: !selectedCheckbox.lob,
                              tpid: selectedCheckbox.tpid,
                              username: selectedCheckbox.username,
                              userstatus: selectedCheckbox.userstatus,
                            })
                          }
                        />
                      }
                      label="Lob"
                    />
                  </Col>
                  <Col md="3">
                    <FormControlLabel
                      control={
                        <Checkbox
                          defaultChecked={selectedCheckbox.tpid}
                          sx={{
                            color: themeConfig.text.primary,
                            "&.Mui-checked": {
                              color: themeConfig.text.primary,
                            },
                          }}
                          onClick={() =>
                            setSelectedCheckbox({
                              user: selectedCheckbox.user,
                              client: selectedCheckbox.client,
                              country: selectedCheckbox.country,
                              city: selectedCheckbox.city,
                              role: selectedCheckbox.role,
                              lob: selectedCheckbox.lob,
                              tpid: !selectedCheckbox.tpid,
                              username: selectedCheckbox.username,
                              userstatus: selectedCheckbox.userstatus,
                            })
                          }
                        />
                      }
                      label="TP Id"
                    />
                  </Col>
                  <Col md="3">
                    <FormControlLabel
                      control={
                        <Checkbox
                          defaultChecked={selectedCheckbox.username}
                          sx={{
                            color: themeConfig.text.primary,
                            "&.Mui-checked": {
                              color: themeConfig.text.primary,
                            },
                          }}
                          onClick={() =>
                            setSelectedCheckbox({
                              user: selectedCheckbox.user,
                              client: selectedCheckbox.client,
                              country: selectedCheckbox.country,
                              city: selectedCheckbox.city,
                              role: selectedCheckbox.role,
                              lob: selectedCheckbox.lob,
                              tpid: selectedCheckbox.tpid,
                              username: !selectedCheckbox.username,
                              userstatus: selectedCheckbox.userstatus,
                            })
                          }
                        />
                      }
                      label="Username"
                    />
                  </Col>
                  <Col md="4">
                    <FormControlLabel
                      control={
                        <Checkbox
                          defaultChecked={selectedCheckbox.userstatus}
                          sx={{
                            color: themeConfig.text.primary,
                            "&.Mui-checked": {
                              color: themeConfig.text.primary,
                            },
                          }}
                          onClick={() =>
                            setSelectedCheckbox({
                              user: selectedCheckbox.user,
                              client: selectedCheckbox.client,
                              country: selectedCheckbox.country,
                              city: selectedCheckbox.city,
                              role: selectedCheckbox.role,
                              lob: selectedCheckbox.lob,
                              tpid: selectedCheckbox.tpid,
                              username: selectedCheckbox.username,
                              userstatus: !selectedCheckbox.userstatus,
                            })
                          }
                        />
                      }
                      label="User Status"
                    />
                  </Col>
                </Row>
              </>
            )}
          </AccordionDetails>
        </Accordion>
      </div>
      <div
        style={{
          paddingLeft: "2rem",
          paddingRight: "2rem",
          marginTop: "1rem",
          marginBottom: "1rem",
        }}
      >
        <Row className="d-flex justify-content-around">
          <Col md="12">
            <TextTitleList
              style={{
                backgroundColor: themeConfig.neutral.gray[900],
                paddingLeft: "1rem",
                paddingRight: "2rem",
                border: "1px solid #DDDDDD",
                borderRadius: "4px 4px 0px 0px",
                paddingTop: "12px",
                paddingBottom: "12px",
              }}
              className="font-weight-bold my-2"
            >
              Users Selection
            </TextTitleList>
          </Col>
          <Col md="6" className="d-flex justify-content-end align-items-center">
            {!showCheckboxes && (
              <CloseButton onClick={() => closeAdvanceSearch()}></CloseButton>
            )}
          </Col>
        </Row>
        <Row className="mx-2 mt-2">
          <div className={classes.row}>
            <div className={classes.column}>
              <Col md="12" className="mb-3">
                <ContentSelect>
                  <Row>
                    <Col md="6">
                      <Form.Label className="font-weight-bold d-flex justify-content-start">
                        Select Country
                      </Form.Label>
                    </Col>
                    <Col md="6" className="d-flex justify-content-end">
                      <Form.Label>Only Option</Form.Label>
                    </Col>
                    <Col md="12">
                      <Select
                        placeholder="Select one option"
                        options={allCountries}
                        styles={SelectStyles}
                        onChange={handleChangeSelectCountry}
                      />
                    </Col>
                  </Row>
                </ContentSelect>
              </Col>
              <Col md="12" className="mb-3">
                <ContentSelect>
                  {loadingRoleByLevel && (
                    <Row>
                      <Col md="12" className="d-flex justify-content-center">
                        <PointersLine color={themeConfig.text.primary} />
                      </Col>
                    </Row>
                  )}
                  {errorRoleByLevel && <option key="0">Error :(</option>}
                  {!loadingRoleByLevel && !errorRoleByLevel && (
                    <Row>
                      <Col md="6">
                        <Form.Label className="font-weight-bold d-flex justify-content-start">
                          Select Role
                        </Form.Label>
                      </Col>
                      <Col md="6" className="d-flex justify-content-end">
                        <Form.Label>Multiple selection option</Form.Label>
                      </Col>
                      <Col md="12">
                        <Select
                          placeholder="Select one option"
                          isMulti
                          options={allRolesByLevel}
                          styles={SelectStyles}
                          onChange={handleChangeSelectRole}
                        />
                      </Col>
                    </Row>
                  )}
                </ContentSelect>
              </Col>
            </div>
            <div className={classes.column}>
              <Col md="12" className="mb-3">
                <ContentSelect>
                  <Row>
                    <Col md="6">
                      <Form.Label className="font-weight-bold d-flex justify-content-start">
                        Select City
                      </Form.Label>
                    </Col>
                    <Col md="6" className="d-flex justify-content-end">
                      <Form.Label>Multiple selection option</Form.Label>
                    </Col>
                    <Col md="12">
                      <Select
                        placeholder="Select one option"
                        isMulti
                        ref={rCities}
                        options={allCities}
                        styles={SelectStyles}
                        onChange={handleChangeSelectCity}
                      />
                    </Col>
                  </Row>
                </ContentSelect>
              </Col>
              <Col md="12" className="mb-3">
                <ContentSelect>
                  <Row>
                    <Col md="6">
                      <Form.Label className="font-weight-bold d-flex justify-content-start">
                        LOB
                      </Form.Label>
                    </Col>
                    <Col md="6" className="d-flex justify-content-end">
                      <Form.Label>Multiple selection option</Form.Label>
                    </Col>
                    <Col md="12">
                      <Select
                        placeholder="Select one option"
                        isMulti
                        options={allLobs}
                        styles={SelectStyles}
                        onChange={handleChangeSelectLob}
                      />
                    </Col>
                  </Row>
                </ContentSelect>
              </Col>
            </div>
          </div>
          <Col md="12">
            <Card
              style={{ backgroundColor: themeConfig.background.light }}
              className="d-flex flex-column-reverse"
            >
              <Row className="m-3">
                <Col
                  className="text-center d-flex align-items-md-center"
                  md="8"
                >
                  <IconGuest className="mr-2" src={guestIcon}></IconGuest> Total
                  users:{" "}
                  <CounterTotalUsers className="ml-2">
                    {totalUsersCount ?? 0}
                  </CounterTotalUsers>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col md="12" className="my-3">
            <SectionWrapper>
              <Row className="d-flex justify-content-end">
                <Col className="mr-2" md="4" xl="3">
                  <ButtonCancel className="w-100" onClick={() => goBack()}>
                    Cancel
                  </ButtonCancel>
                </Col>
                <Col md="4" xl="3">
                  <ButtonCreateGroup
                    className="w-100"
                    onClick={() => createGroup()}
                  >
                    {labelOfButton ? labelOfButton : "Create Group"}
                  </ButtonCreateGroup>
                </Col>
              </Row>
            </SectionWrapper>
          </Col>
        </Row>
      </div>
      {loadingAdvanceUsers && <ModalLoader />}
    </>
  );
};

export default DownloadUserManagement;
